/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Regenerate_TitleInputs */



/**
* | output |
* | --- |
* | "Regenerate secret" |
*
* @param {Developer_Regenerate_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_regenerate_title = /** @type {((inputs?: Developer_Regenerate_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Regenerate_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Régénérer le secret")
	if (locale === "es") return /** @type {LocalizedString} */ ("Regenerar secreto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Regenerar secret")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rigenera secret")
	return /** @type {LocalizedString} */ ("Regenerate secret")
});